module.exports = __webpack_public_path__ + "static/media/S16.f41df0a6.png";